<template>
  <v-dialog v-model="homeworkDialog" fullscreen>
    <template #activator="{ on }">
      <v-btn
        v-show="!!homeworks.length || isTeacher"
        small
        width="100"
        class="text-capitalize comment__div"
        color="white"
        v-on="on"
        >Reassign</v-btn
      >
    </template>
    <v-card>
      <v-card-title>
        <span> Reassign </span>
        <v-spacer />
        <v-btn class="white--text text-capitalize" color="#FF347C" @click="homeworkDialog = false">
          Close
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text--primary">
        <div v-for="(item, index) in homeworks" :key="item.uuid">
          <HomeworkDetails :item="item" :index="index" @homework-deleted="onDeleted">
            <template #title>
              <span></span>
            </template>
          </HomeworkDetails>
        </div>
        <CreateHomeworkDialog
          v-model="createDialog"
          max-width="800"
          :location="location"
          :loadingAssign="loadingAssign"
          :createFields="createFields"
          @new-homework="onNewHomework"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import directionMixin from "@/mixins/directionMixin";
import studentMixin from "@/mixins/studentMixin";
import { getHomeworks } from "@/api/api";
import CreateHomeworkDialog from "./Stepper/Homework/CreateHomeworkDialog.vue";
import { assignHomework } from "@/api/api";
import HomeworkDetails from "./Stepper/Homework/HomeworkDetails.vue";

export default {
  components: { CreateHomeworkDialog, HomeworkDetails },
  props: {
    speak: { type: String, required: true },
  },
  mixins: [directionMixin, studentMixin],
  data() {
    return {
      homeworkDialog: false,
      createDialog: false,
      loadingAssign: false,
      homeworks: [],
    };
  },
  computed: {
    field() {
      return `${this.direction}_speak`;
    },
    fieldUuid() {
      return `${this.field}__uuid`;
    },
    filterFields() {
      return {
        [this.fieldUuid]: this.speak,
      };
    },
    createFields() {
      return {
        [this.field]: this.speak,
      };
    },
    disabled() {
      return this.loading || (!this.homeworks.length && !this.isTeacher);
    },
    location() {
      if (this.direction === "practice") {
        return "PRACTICE";
      }
      return "LIVE";
    },
    profile() {
      return this.$store.getters.profile;
    },
  },
  watch: {
    async homeworkDialog(v) {
      if (!v) return;
      await this.$nextTick();
      if (!this.homeworks.length && this.isTeacher) this.createDialog = true;
    },
  },
  mounted() {
    this.fetchHomeworks();
  },
  methods: {
    async fetchHomeworks() {
      const params = {
        teacher_lesson__uuid: this.$store.getters["lesson/teacher_lesson"].uuid,
        location: this.location,
        students__student__email: this.student.email,
        ...this.filterFields,
      };
      if (!Object.keys(this.filterFields).length) {
        params.not_speak = true;
      }
      if (this.profile.role === "TEACHER") {
        params.teacher__email = this.profile.email;
      }
      const customs = await getHomeworks({
        ...params,
        type: "Custom",
      });
      this.homeworks = customs.data.results;
    },
    onDeleted(uuid) {
      const index = this.homeworks.findIndex((item) => item.uuid === uuid);
      if (index > -1) {
        this.homeworks.splice(index, 1);
      }
    },
    async onNewHomework(homework) {
      try {
        this.loadingAssign = true;
        await assignHomework({
          homework: homework.uuid,
          student: this.student.email,
        });
        this.createDialog = false;
        const newHomework = {
          ...homework,
          students: [
            {
              email: this.student.email,
              uuid: this.student.uuid,
            },
          ],
        };
        this.homeworks.push(newHomework);
      } finally {
        this.loadingAssign = false;
      }
    },
  },
};
</script>
<style scoped>
.comment__div {
  border: dashed #29284c 2px !important;
  border-radius: 10px;
}
</style>
